import React from "react";
import { getViewInfo } from "src/common/attrView";
import { seedSeparators } from "src/common/attrView/viewFormItems/Separator";
import { imgSrc, urlForDownload } from "src/components/PlmUploader/imgSrc";
import { PageUrl } from "src/routes/PageUrl";
import { makeUrl } from "src/routes/makeUrl";
import { AttrTypeName } from "src/types/AttrType";
import { classNames } from "src/common/classNames";
import { MakeLabelParams } from "../../../types/MakeLabelParams";
import { getAttrLabelTreeData } from "../../../utils/getAttrLabelTreeData";
import { FileLinkLabel } from "./FileLinkLabel";
import styles from "./LinkInternal.module.less";
import { SimpleText } from "../../SimpleText/SimpleText";

const labelCreateMap: Record<string, (value: string) => React.ReactNode> = {
  [AttrTypeName.image]: (value: string) => <FileLinkLabel value={value} />,
  [AttrTypeName.file]: (value: string) => <FileLinkLabel value={value} />,
  standart: (value: string) => value,
};

type PropsLinkStd = {
  params: MakeLabelParams;
};

export const LinkInternal: React.FC<PropsLinkStd> = ({ params }) => {
  const { attribute, typesMap } = params;
  const values = getAttrLabelTreeData(
    params.attribute,
    params.labelTreeData,
  )?.labels;
  const viewInfo = getViewInfo(attribute.viewType);
  const linkCreateMap: Record<string, (value: string) => string> = {
    [AttrTypeName.image]: (value: string) => imgSrc(value, "small"),
    [AttrTypeName.file]: (value: string) => urlForDownload(false, value),
    [AttrTypeName.object]: (value: string) =>
      makeUrl(PageUrl.entityCard, { id: value }),
  };

  const linkFn = linkCreateMap[typesMap[attribute.valueType] || ""];
  if (!linkFn) return "невозможно создать ссылку";

  const labelFn =
    labelCreateMap[typesMap[attribute.valueType] ?? ""] ||
    labelCreateMap.standart;

  const labelsWithSeparator = seedSeparators(
    values?.map((val) => ({
      content: (
        <a
          key={val}
          href={linkFn(val)}
          target="_blank"
          onClick={(e) => e.stopPropagation()}
          rel="noreferrer"
          className={classNames([
            styles.link,
            styles[viewInfo?.appearance?.view?.overflow || ""],
          ])}
        >
          {labelFn?.(val)}
        </a>
      ),
      key: val,
    })) ?? [],
    viewInfo?.appearance?.view?.separator,
  );

  return <SimpleText values={labelsWithSeparator} viewInfo={viewInfo} />;
};
